import { TourConfig } from './types';

export const MainDashboardTour: TourConfig = {
    id: 'main-dashboard',
    name: 'Main Dashboard Tour',
    description: 'Learn how to navigate the dashboard and add monitoring cards',
    steps: [
        {
            selector: '[data-tour="asset-drawer"]',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">Asset Drawer</h3>
                    <p>This is the Asset Drawer where you can browse and select assets.</p>
                    <p className="mt-2">You can add cards to your dashboard by hovering over element and pressing three dots which will open up a menu with options.</p>
                </div>
            ),
            position: 'right' as const,
            mobilePosition: 'center' as const,
        },
        {
            selector: 'body',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">Adding Dashboard Cards</h3>
                    <p>Added three cards:</p>
                    <ul className="list-disc list-inside mt-2 space-y-1">
                        <li>OEE for workcenter 103</li>
                        <li>Machine Status for group 1 of workcenter 103</li>
                        <li>Machine View for 104062</li>
                    </ul>
                </div>
            ),
            mobilePosition: 'center' as const,
            action: () => {
                const controls = (window as any).assetTreeControls;
                if (controls && controls.addTourCards) {
                    const addedCards = controls.addTourCards();
                    (window as any).tourCardGuids = addedCards;
                    const setSteps = (window as any).__tourSetSteps__;
                    if (setSteps && addedCards.length >= 3) {
                        const currentSteps = MainDashboardTour.steps;
                        currentSteps[2].selector = `[data-tour="card-oee-${addedCards[0].guid}"]`;
                        currentSteps[3].selector = `[data-tour="card-mstatus-${addedCards[1].guid}"]`;
                        currentSteps[4].selector = `[data-tour="card-machine-${addedCards[2].guid}"]`;
                        setSteps([...currentSteps]);
                    }
                } else {
                    console.error('[TOUR] Asset tree controls not available');
                }
            },
            actionAfter: async () => {
                await new Promise(resolve => setTimeout(resolve, 500));
            },
        },
        {
            selector: 'body',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">OEE Card</h3>
                    <p>The <strong>OEE (Overall Equipment Effectiveness)</strong> card shows:</p>
                    <ul className="list-disc list-inside mt-2 space-y-1">
                        <li>Performance metrics for the machine</li>
                        <li>Availability, Performance, and Quality indicators</li>
                        <li>Real-time efficiency data</li>
                    </ul>
                    <p className="mt-2">Use this card to monitor machine productivity.</p>
                </div>
            ),
            position: 'bottom' as const,
            mobilePosition: 'center' as const,
        },
        {
            selector: 'body',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">Machine Status Card</h3>
                    <p>The <strong>Machine Status</strong> card displays:</p>
                    <ul className="list-disc list-inside mt-2 space-y-1">
                        <li>Current operational state of machines</li>
                        <li>Running, stopped, or error states</li>
                        <li>Quick overview of machine health</li>
                    </ul>
                    <p className="mt-2">Monitor all machines in this group at a glance.</p>
                </div>
            ),
            position: 'center' as const,
            mobilePosition: 'center' as const,
        },
        {
            selector: 'body',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">Machine View Card</h3>
                    <p>The <strong>Machine View</strong> card provides:</p>
                    <ul className="list-disc list-inside mt-2 space-y-1">
                        <li>Detailed information about a specific machine</li>
                        <li>Current parameters and settings</li>
                        <li>Historical data and trends</li>
                    </ul>
                    <p className="mt-2">Deep dive into individual machine performance.</p>
                </div>
            ),
            position: 'center' as const,
            mobilePosition: 'center' as const,
        },
        {
            selector: 'body',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">Tour Complete! 🎉</h3>
                    <p>You've learned the basics of the Main Dashboard:</p>
                    <ul className="list-disc list-inside mt-2 space-y-1">
                        <li>How to use the Asset Drawer</li>
                        <li>Adding cards to your dashboard</li>
                        <li>Understanding different card types</li>
                    </ul>
                    <p className="mt-2">The demonstration cards will be removed when you close this tour.</p>
                    <p className="mt-1">You can now customize your dashboard by adding or removing cards as needed!</p>
                </div>
            ),
            mobilePosition: 'center' as const,
        },
    ],
};
